// Returns date in format YYYY-MM-DD
exports.formatCalendarDate = (date) => {
  let month = '' + (date.getMonth() + 1);
  let day = '' + date.getDate();
  let year = date.getFullYear();

  if (month.length < 2) {
    month = '0' + month;
  }
  if (day.length < 2) {
    day = '0' + day;
  }

  return [year, month, day].join('-');
};



// WEBPACK FOOTER //
// ./common/libs/date.js